import { ReactNode } from "react";
import { Box, Paper, Typography, alpha, useTheme } from "@mui/material";

interface IModernCard {
  title?: string;
  subtitle?: string;
  icon?: ReactNode;
  children: ReactNode;
}

export const ModernCard = ({ title, subtitle, icon, children }: IModernCard) => {
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;

  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 2, md: 2.5 },
        borderRadius: "16px",
        borderColor: alpha(primaryColor, 0.15),
        boxShadow: `0 8px 24px ${alpha(primaryColor, 0.08)}`,
      }}
    >
      {title && (
        <Box sx={{ display: "flex", alignItems: "center", mb: subtitle ? 1 : 2 }}>
          <Box sx={{ color: primaryColor, display: "flex", alignItems: "center" }}>
            {icon}
          </Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, }}>
            {title}
          </Typography>
        </Box>
      )}

      {subtitle && (
        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "text.secondary", mb: 2 }}>
          {subtitle}
        </Typography>
      )}
      {children}
    </Paper>
  );
};
